import { faChevronDown, faChevronRight, faUserGroup } from "@fortawesome/pro-regular-svg-icons";
import { IAppView, TAppView } from "../../store/app/appUtils";
import { useCarbonSelector, selectAppView, useCarbonDispatch } from "../../store/carbonStore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { AppSliceActions } from "../../store/app/appSlice";
import { faArrowsRotate, faSparkles, faUserGear, faUserLock } from "@fortawesome/pro-duotone-svg-icons";
import { faUser } from "@fortawesome/pro-solid-svg-icons";
import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { GcmUserPermission } from "userful-chronos-app-common-js/dist/models/gcm-user-permission";
import { SideNav } from "userful-chronos-common-ui/dist";

interface IProps {
    show: boolean;
    onAction: () => void;
}

const CONTENT = {
    CONSTELLATIONS: "Constellation List",
    USERS: "Users",
    USER_GROUPS: "Role Permissions",
    BACKUP_AND_RESTORE: "Backup & Restore",
};

export default function Navigation(props: IProps) {
    const [userManagementShow, setUserManagementShow] = useState<boolean>(true);
    // const [constellationManagementShow, setConstellationManagementShow] = useState<boolean>(true);
    const [showContent, setShowContent] = useState<string>("");

    const dispatch = useCarbonDispatch();

    const appView: IAppView = useCarbonSelector(selectAppView);
    const permissions: GcmUserPermission = getGlobalStates().gcmUserPermission;

    const menuItems = [
        {
            subMenuHeaderTitle: "Constellation Management",
            tooltip: "Manage and observe Infinity systems, Clusters, and Constellations.",
            icon: {
                iconName: faSparkles,
            },
            subMenu: [
                {
                    title: "Constellation List",
                    tooltip: "View a comprehensive list of all managed constellations.",
                    icon: {
                        iconName: faSparkles,
                    },
                    id: "constalation-list",
                },
                {
                    title: "Backup & Restore",
                    tooltip:
                        "Configure and initiate backups of system configurations and data, and restore from previous backups.",
                    icon: {
                        iconName: faArrowsRotate,
                    },
                    id: "backup-restore",
                },
            ],
        },
        permissions.isUserViewer &&
            userManagementShow && {
                subMenuHeaderTitle: "User Manager",
                tooltip: "Administer user accounts and their access privileges.",
                icon: {
                    iconName: faUser,
                },
                subMenu: [
                    {
                        title: "Users",
                        tooltip: "View and manage individual user accounts authorized to access the system.",
                        icon: {
                            iconName: faUser,
                        },
                        id: "users",
                    },
                    {
                        title: "Role Permissions",
                        tooltip:
                            "Define and manage sets of permissions that can be assigned to users, controlling their access to features and systems.",
                        icon: {
                            iconName: faUserGroup,
                        },
                        id: "role-permissions",
                    },
                ],
            },
    ];

    const handleChangeShowContent = (selected: string) => {
        const foundKey = Object.keys(CONTENT).find((k) => CONTENT[k] === selected) as TAppView;

        dispatch(AppSliceActions.setAppView({ type: foundKey, id: { value: "NOT_DEFINED" } }));
    };

    useEffect(() => {
        if (appView.type === "CONSTELLATIONS" || appView.type === "CLUSTER" || appView.type === "DEVICE") {
            setShowContent(CONTENT.CONSTELLATIONS);
        } else if (appView.type === "USERS" || appView.type === "USER") {
            setShowContent(CONTENT.USERS);
        } else if (appView.type === "USER_GROUPS" || appView.type === "USER_GROUP") {
            setShowContent(CONTENT.USER_GROUPS);
        } else if (appView.type === "BACKUP_AND_RESTORE") {
            setShowContent(CONTENT.BACKUP_AND_RESTORE);
        }
    }, [appView]);

    return (
        <SideNav
            show={props.show}
            handleChangeShowContent={handleChangeShowContent}
            showContent={showContent}
            menuItems={menuItems}
            onAction={props.onAction}
        />
    );
}
